import script from "./captcha-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./captcha-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./captcha-dialog.vue?vue&type=style&index=0&id=e1480f80&lang=scss"

const __exports__ = script;

export default __exports__